import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import { userId, type UserId } from './User.js'

/** Identifier type for public.view_as_log_ */
export type ViewAsLogId = string & { __brand: 'ViewAsLogId' }

/** Represents the table public.view_as_log_ */
export default interface ViewAsLogTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<ViewAsLogId, ViewAsLogId | undefined, ViewAsLogId>

  /** Database type: pg_catalog.uuid */
  actorUserId: ColumnType<UserId | null, UserId | null, UserId | null>

  /** Database type: pg_catalog.text */
  actorEmail: ColumnType<string, string, string>

  /** Database type: pg_catalog.uuid */
  targetUserId: ColumnType<UserId | null, UserId | null, UserId | null>

  /** Database type: pg_catalog.text */
  targetEmail: ColumnType<string, string, string>

  /** Database type: pg_catalog.timestamptz */
  startedAt: ColumnType<Date, Date | string | undefined, Date | string>

  /** Database type: pg_catalog.timestamptz */
  endedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.text */
  endReason: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.int4 */
  requestCount: ColumnType<number, number | undefined, number>

  /** Database type: pg_catalog.timestamptz */
  lastRequestAt: ColumnType<
    Date | null,
    Date | string | null,
    Date | string | null
  >
}

export type ViewAsLog = Selectable<ViewAsLogTable>

export type ViewAsLogInitializer = Insertable<ViewAsLogTable>

export type ViewAsLogMutator = Updateable<ViewAsLogTable>

export const viewAsLogId = z.string() as unknown as z.Schema<ViewAsLogId>

export const viewAsLog = z.object({
  id: viewAsLogId,
  actorUserId: userId.nullable(),
  actorEmail: z.string(),
  targetUserId: userId.nullable(),
  targetEmail: z.string(),
  startedAt: z.coerce.date(),
  endedAt: z.coerce.date().nullable(),
  endReason: z.string().nullable(),
  requestCount: z.number(),
  lastRequestAt: z.coerce.date().nullable(),
}) as unknown as z.Schema<ViewAsLog>

export const viewAsLogInitializer = z.object({
  id: viewAsLogId.optional(),
  actorUserId: userId.optional().nullable(),
  actorEmail: z.string(),
  targetUserId: userId.optional().nullable(),
  targetEmail: z.string(),
  startedAt: z.coerce.date().optional(),
  endedAt: z.coerce.date().optional().nullable(),
  endReason: z.string().optional().nullable(),
  requestCount: z.number().optional(),
  lastRequestAt: z.coerce.date().optional().nullable(),
}) as unknown as z.Schema<ViewAsLogInitializer>

export const viewAsLogMutator = z.object({
  id: viewAsLogId.optional(),
  actorUserId: userId.optional().nullable(),
  actorEmail: z.string().optional(),
  targetUserId: userId.optional().nullable(),
  targetEmail: z.string().optional(),
  startedAt: z.coerce.date().optional(),
  endedAt: z.coerce.date().optional().nullable(),
  endReason: z.string().optional().nullable(),
  requestCount: z.number().optional(),
  lastRequestAt: z.coerce.date().optional().nullable(),
}) as unknown as z.Schema<ViewAsLogMutator>
